// Norne branding
import norneLightLogo from "./svg/norne/norne-logo-light.svg";
import norneBlueLogo from "./svg/norne/norne-logo-blue.svg";
import norneSingleWhiteLogo from "./svg/norne/norne-logo-single-white.svg";
import norneStockIcon from "./svg/norne/norne-aksjehandel-ikon.svg";
import nornePolesIcon from "./svg/norne/norne-soyle-ikon.svg";
import norneWavesIcon from "./svg/norne/norne-bolger-ikon.svg";
import norneFundIcon from "./svg/norne/norne-fond-ikon.svg";
import norneLineIcon from "./svg/norne/norne-linje-d-ikon.svg";
import norneLineBlueIcon from "./svg/norne/norne-line-blue.svg";
import norneMailIcon from "./svg/norne/norne-mail-ikon.svg";
import norneDotsDiagramIcon from "./svg/norne/norne-prikker-diagram-ikon.svg";
import norneDotsIcon from "./svg/norne/norne-prikker-ikon.svg";
import norneUserIcon from "./svg/norne/norne-bruker-ikon.svg";
import collapseSmallIcon from "./svg/norne/collapse-small.svg";
import expandSmallRightIcon from "./svg/norne/expand-small-right.svg";

import checkmarkCheckedIcon from "./svg/norne/checkmark-checked.svg";
import checkmarkEmptyIcon from "./svg/norne/checkmark-empty.svg";

// Hero
import ellipsisVerticalIcon from "./svg/hero/ellipsis-vertical.svg";
import arrowPathRoundedSquare from "./svg/hero/arrow-path-rounded-square.svg";
import chevronDownIcon from "./svg/hero/chevron-down.svg";
import chevronUpIcon from "./svg/hero/chevron-up.svg";
import barsIcon from "./svg/hero/bars.svg";
import xMarkIcon from "./svg/hero/x-mark.svg";
import bankNotesIcon from "./svg/hero/banknotes.svg";
import inboxIcon from "./svg/hero/inbox.svg";
import arrowRightOnRectangleIcon from "./svg/hero/arrow-right-on-rectangle.svg";
import arrowLeftOnRectangleIcon from "./svg/hero/arrow-left-on-rectangle.svg";
import circleStackIcon from "./svg/hero/circle-stack.svg";
import userHeroIcon from "./svg/hero/user.svg";
import checkIcon from "./svg/hero/check.svg";
import globeHeroIcon from "./svg/hero/globe-alt.svg";
import checkCircleIcon from "./svg/hero/check-circle.svg";
import shoppingCartIcon from "./svg/hero/shopping-cart.svg";
import arrowsRightLeftIcon from "./svg/hero/arrows-right-left.svg";
import trashIcon from "./svg/hero/trash.svg";
import arrowSmallLeftIcon from "./svg/hero/arrow-small-left.svg";
import arrowSmallRightIcon from "./svg/hero/arrow-small-right.svg";
import calendarDaysIcon from "./svg/hero/calendar-days.svg";
import funnelIcon from "./svg/hero/funnel.svg";
import magnifyingGlassIcon from "./svg/hero/magnifying-glass.svg";
import paperClipIcon from "./svg/hero/paper-clip.svg";
import printerIcon from "./svg/hero/printer.svg";
import pencilSquareIcon from "./svg/hero/pencil-square.svg";
import arrowUturnLeftIcon from "./svg/hero/arrow-uturn-left.svg";
import buildingOfficeIcon from "./svg/hero/building-office.svg";
import arrowLongLeftIcon from "./svg/hero/arrow-long-left.svg";
import arrowTrendingIcon from "./svg/hero/arrow-trending.svg";
import square2StackIcon from "./svg/hero/square-2-stack.svg";
import plusCircleIcon from "./svg/hero/plus-circle.svg";
import usersIcon from "./svg/hero/users.svg";
import questionMarkCircleIcon from "./svg/hero/question-mark-circle.svg";
import chevronRightIcon from "./svg/hero/chevron-right.svg";
import homeIcon from "./svg/hero/home.svg";
import rocketLaunchIcon from "./svg/hero/rocket-launch.svg";
import trophyIcon from "./svg/hero/trophy.svg";
import ellipsisHorizontalCircleIcon from "./svg/hero/ellipsis-horizontal-circle.svg";
import arrowDownTrayIcon from "./svg/hero/arrow-down-tray.svg";
import arrowRightIcon from "./svg/hero/arrow-right.svg";
import documentArrowDownIcon from "./svg/hero/document-arrow-down.svg";
import settingsIcon from "./svg/hero/settings.svg";
import pencilIcon from "./svg/hero/pencil.svg";
import arrowLongDown from "./svg/hero/arrow-long-down.svg";
import arrowLongUp from "./svg/hero/arrow-long-up.svg";
import chevronUpDown from "./svg/hero/chevron-up-down.svg";
import phoneIcon from "./svg/hero/phone.svg";
import chevronLeftIcon from "./svg/hero/chevron-left.svg";
import chevronDoubleLeftIcon from "./svg/hero/chevron-double-left.svg";
import chevronDoubleRightIcon from "./svg/hero/chevron-double-right.svg";
import arrowTopRightOnSquareIcon from "./svg/hero/arrow-top-right-on-square.svg";
import exclamationCircleIcon from "./svg/hero/exclamation-circle.svg";
import exclamationTriangleIcon from "./svg/hero/exclamation-triangle.svg";
import arrowTrendingUpIcon from "./svg/hero/arrow-trending-up.svg";
import clockIcon from "./svg/hero/clock.svg";
import starIcon from "./svg/hero/star.svg";
import starFilledIcon from "./svg/hero/starFilled.svg";
import giftTopIcon from "./svg/hero/gift-top.svg";
import ellipsisHorizontalIcon from "./svg/hero/ellipsis-horizontal.svg";
import arrowUpTrayIcon from "./svg/hero/arrow-up-tray.svg";
import bankLibraryIcon from "./svg/hero/bank-library.svg";
import bellAlertIcon from "./svg/hero/bell-alert.svg";
import bellAlertSolidIcon from "./svg/hero/bell-alert-solid.svg";
import bellIcon from "./svg/hero/bell.svg";
import bellSlashIcon from "./svg/hero/bell-slash.svg";
import arrowsPointingOut from "./svg/hero/arrows-pointing-out.svg";
import lightBulbIcon from "./svg/hero/light-bulb.svg";
import linkIcon from "./svg/hero/link.svg";
import documentIcon from "./svg/hero/document.svg";
import xCircleIcon from "./svg/hero/x-circle.svg";
import minusIcon from "./svg/hero/minus.svg";
import plusIcon from "./svg/hero/plus.svg";
import chartBarIcon from "./svg/hero/chart-bar.svg";
import chatBubbleLeftRightIcon from "./svg/hero/chat-bubble-left-right.svg";
import modernHouseIcon from "./svg/hero/modern-house-icon.svg";
import computerDesktopIcon from "./svg/hero/computer-desktop-icon.svg";
import wrenchScrewdriverIcon from "./svg/hero/wrench-screwdriver-icon.svg";
import heartIcon from "./svg/hero/heart-icon.svg";
import boltIcon from "./svg/hero/bolt-icon.svg";
import puzzlePieceIcon from "./svg/hero/puzzle-piece-icon.svg";
import caldendarIcon from "./svg/hero/calendar.svg";

// Font awesome
import facebookIcon from "./svg/fontawesome/facebook.svg";
import instagramIcon from "./svg/fontawesome/instagram.svg";
import linkedinIcon from "./svg/fontawesome/linkedin.svg";
import piggyBankIcon from "./svg/fontawesome/piggy-bank.svg";
import scaleBalanced from "./svg/fontawesome/scale-balanced.svg";

import indicatorIcon from "./svg/norne/indicator.svg";
import factoryIndustryIcon from "./svg/factory-industry.svg";
import weaponIcon from "./svg/weapon.svg";
import alcoholIcon from "./svg/alcohol.svg";
import fossilFuelsIcon from "./svg/fossil-fuels.svg";
import controversialWeaponsIcon from "./svg/controversial-weapons.svg";
import tobaccoIcon from "./svg/tobacco.svg";
import pesticidesIcon from "./svg/pesticides.svg";
import palmOilIcon from "./svg/palm-oil.svg";
import nuclearIcon from "./svg/nuclear.svg";
import militaryContractingIcon from "./svg/military-contracting.svg";
import gmoIcon from "./svg/gmo.svg";
import gamblingIcon from "./svg/gambling.svg";
import animalTestingIcon from "./svg/animal-testing.svg";
import adultEntertainmentIcon from "./svg/adult-entertainment.svg";
import pensionIcon from "./svg/pension.svg";
import targetIcon from "./svg/target.svg";
import durationIcon from "./svg/duration.svg";
import chartUpwardIcon from "./svg/chart-upward.svg";
import equilibriumIcon from "./svg/equilibrium.svg";

const Icons = {
  durationIcon,
  targetIcon,
  pensionIcon,
  caldendarIcon,
  pesticidesIcon,
  adultEntertainmentIcon,
  animalTestingIcon,
  gamblingIcon,
  gmoIcon,
  militaryContractingIcon,
  nuclearIcon,
  palmOilIcon,
  tobaccoIcon,
  controversialWeaponsIcon,
  fossilFuelsIcon,
  alcoholIcon,
  weaponIcon,
  factoryIndustryIcon,
  puzzlePieceIcon,
  boltIcon,
  heartIcon,
  wrenchScrewdriverIcon,
  computerDesktopIcon,
  modernHouseIcon,
  chatBubbleLeftRightIcon,
  scaleBalanced,
  chartBarIcon,
  plusIcon,
  minusIcon,
  xCircleIcon,
  bellSlashIcon,
  bellAlertSolidIcon,
  ellipsisVerticalIcon,
  indicatorIcon,
  lightBulbIcon,
  piggyBankIcon,
  documentIcon,
  linkIcon,
  arrowsPointingOut,
  arrowPathRoundedSquare,
  bellIcon,
  bellAlertIcon,
  bankLibraryIcon,
  ellipsisHorizontalIcon,
  arrowUpTrayIcon,
  giftTopIcon,
  clockIcon,
  arrowTrendingUpIcon,
  starIcon,
  starFilledIcon,
  exclamationTriangleIcon,
  exclamationCircleIcon,
  arrowTopRightOnSquareIcon,
  chevronLeftIcon,
  chevronDoubleLeftIcon,
  chevronDoubleRightIcon,
  pencilIcon,
  arrowRightIcon,
  documentArrowDownIcon,
  arrowDownTrayIcon,
  facebookIcon,
  linkedinIcon,
  instagramIcon,
  ellipsisHorizontalCircleIcon,
  trophyIcon,
  rocketLaunchIcon,
  homeIcon,
  chevronRightIcon,
  questionMarkCircleIcon,
  usersIcon,
  plusCircleIcon,
  square2StackIcon,
  arrowLongLeftIcon,
  buildingOfficeIcon,
  arrowUturnLeftIcon,
  pencilSquareIcon,
  printerIcon,
  paperClipIcon,
  magnifyingGlassIcon,
  funnelIcon,
  calendarDaysIcon,
  arrowSmallLeftIcon,
  arrowSmallRightIcon,
  trashIcon,
  arrowsRightLeftIcon,
  shoppingCartIcon,
  chevronDownIcon,
  chevronUpIcon,
  barsIcon,
  xMarkIcon,
  bankNotesIcon,
  inboxIcon,
  arrowRightOnRectangleIcon,
  arrowLeftOnRectangleIcon,
  arrowTrendingIcon,
  circleStackIcon,
  userHeroIcon,
  checkIcon,
  globeHeroIcon,
  checkCircleIcon,
  phoneIcon,
  settingsIcon,
  // Norne logos and icons
  norneLightLogo,
  norneBlueLogo,
  norneSingleWhiteLogo,
  norneStockIcon,
  nornePolesIcon,
  norneWavesIcon,
  norneFundIcon,
  norneLineIcon,
  norneLineBlueIcon,
  norneMailIcon,
  norneDotsDiagramIcon,
  norneDotsIcon,
  norneUserIcon,
  collapseSmallIcon,
  expandSmallRightIcon,
  checkmarkCheckedIcon,
  checkmarkEmptyIcon,
  arrowLongDown,
  arrowLongUp,
  chevronUpDown,
  chartUpwardIcon,
  equilibriumIcon,
} as const;

export default Icons;
